import { Link } from "react-router-dom";
import { FIRM, TIMELINE } from "@/data/content";
import { PageHero, Breadcrumbs, TestimonialBand, FadeIn } from "@/components/Shared";

export default function About() {
  return (
    <main data-testid="about-page">
      <PageHero
        eyebrow="Operating since the 1950s"
        title="A reputation built on tenacity, judgment and client care."
        lead="Hallinan Blackburn Gittings & Nott are specialists in defending serious and complex crime and fraud — market leaders for our expertise, bespoke approach and client care."
      />
      <Breadcrumbs items={[{ label: "About" }]} />

      {/* Why clients choose us */}
      <section className="bg-white py-20 sm:py-28 lg:py-32">
        <div className="brand-container">
          <FadeIn>
            <div className="mb-12 aspect-[16/7] overflow-hidden rounded-sm border border-slate-200 md:rounded">
              <img
                src={FIRM.officeImage}
                alt="Professional law firm office interior"
                className="size-full object-cover"
                data-testid="about-office-image"
              />
            </div>
          </FadeIn>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {[
              {
                title: "Discreet by design",
                text: "Our client base includes high profile individuals and cases, however we pride ourselves on our low profile approach — discreet, empathetic and entirely professional.",
              },
              {
                title: "Every avenue pursued",
                text: "We rigorously pursue all avenues, keeping you involved and updated every step of the way. No stone is left unturned in defence of our clients.",
              },
              {
                title: "Public and private clients",
                text: "We defend both publicly and privately funded clients, maintaining our own client contract with the Legal Aid Agency, from the Magistrates' Court to the Supreme Court.",
              },
            ].map((item, i) => (
              <FadeIn key={i} delay={i * 0.1}>
                <div className="brand-panel-pale h-full rounded-sm border-t-2 border-brand-gold p-12 md:rounded">
                  <h3 className="text-lg font-medium text-brand-navy">{item.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-600">{item.text}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="brand-panel-pale py-20 sm:py-28 lg:py-32" data-testid="timeline-section">
        <div className="brand-container">
          <FadeIn>
            <p className="brand-eyebrow">
              Our story
            </p>
            <h2 className="brand-heading mt-4 text-3xl sm:text-4xl">
              Seven decades of defence.
            </h2>
          </FadeIn>
          <div className="mt-14 space-y-0">
            {TIMELINE.map((item, i) => (
              <FadeIn key={i} delay={i * 0.08}>
                <div className="grid grid-cols-1 gap-4 border-l-2 border-brand-gold/50 py-8 pl-8 sm:grid-cols-12 sm:gap-8">
                  <div className="sm:col-span-3">
                    <p className="text-2xl font-light tracking-tight text-brand-gold">
                      {item.period}
                    </p>
                  </div>
                  <div className="sm:col-span-9">
                    <h3 className="text-xl font-medium text-brand-navy">{item.title}</h3>
                    <p className="mt-2 max-w-2xl leading-relaxed text-slate-600">{item.text}</p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
          <FadeIn delay={0.2}>
            <Link
              to="/team"
              className="mt-10 inline-block rounded-sm border border-brand-navy px-8 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-brand-navy transition-colors duration-200 hover:bg-brand-navy hover:text-white"
              data-testid="about-meet-team-button"
            >
              Meet the team
            </Link>
          </FadeIn>
        </div>
      </section>

      <TestimonialBand />
    </main>
  );
}
